<div class="invoice-gallery gallery-container">
    <div class="product-gallery__featured p-3 pb-0">
        <div *ngIf="invoice?.isMultiPage && showPdfZoomReviewToggle"
            class="mb-2">
            <div class="d-flex justify-content-end">
                <div class="switch-toggle switch-view">
                    <div class="toggle-button-cover">
                        <div class="button-cover">
                            <div class="button b2">
                                <input type="checkbox"
                                    class="checkbox"
                                    [checked]="usePdfZoomReview"
                                    (change)="onUsePdfZoomReviewChange($any($event.target).checked)"
                                    tabindex="0" />
                                <div class="knobs"><span>Standard</span></div>
                                <div class="layer"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <owl-carousel-o [options]="carouselOptions"
            (mouseleave)="endDrag()"
            #owlCar>
            <ng-container *ngIf="invoice">
                <ng-template carouselSlide
                    [id]="invoice.id">
                    <app-zoom *ngIf="invoice?.typeAtPage(page).includes('image')"
                        [name]="invoice?.nameAtPage(page)"
                        [sources]="invoice.sources"
                        [path]="invoice?.pathAtPage(page)"
                        [isFullScreen]="isFullScreen"
                        [showFullScreenBtn]="true"
                        [isDuplicate]="invoice?.isDuplicate"
                        (fullScreenEvent)="onFullScreenToggle($event)">
                    </app-zoom>
                    <app-pdf-zoom *ngIf="!invoice?.typeAtPage(page).includes('image') && !usePdfZoomReview"
                        [name]="invoice?.nameAtPage(page)"
                        [sources]="invoice.sources"
                        [path]="invoice?.pathAtPage(page)"
                        [page]="invoice.getSourcePage(page) + 1"
                        [isFullScreen]="isFullScreen"
                        [showFullScreenBtn]="true"
                        [isDuplicate]="invoice?.isDuplicate"
                        (fullScreenEvent)="onFullScreenToggle($event)">
                    </app-pdf-zoom>
                    <app-pdf-zoom-review *ngIf="!invoice?.typeAtPage(page).includes('image') && usePdfZoomReview"
                        [name]="invoice?.nameAtPage(page)"
                        [sources]="invoice.sources"
                        [path]="invoice?.pathAtPage(page)"
                        [page]="invoice.getSourcePage(page) + 1"
                        [isFullScreen]="isFullScreen"
                        [showFullScreenBtn]="true"
                        [isDuplicate]="invoice?.isDuplicate"
                        (fullScreenEvent)="onFullScreenToggle($event)">
                    </app-pdf-zoom-review>
                </ng-template>
            </ng-container>
        </owl-carousel-o>
    </div>
    <div class="product-gallery__carousel"
        *ngIf="invoice?.isMultiPage">
        <div class="d-flex gap-2 align-items-center justify-content-center">
            <div class="align-self-center">
                <button type="button"
                    (click)="onChangePage(page - 1, true)"
                    pmdBtn
                    [attr.color]="buttonColor ? buttonColor : null"
                    pmdRipple
                    size="xs"
                    class="mr-2 btn btn-arrow btn-outline-dark">
                    <i class="material-icons material-icons-outlined pmd-icon-sm">
                        arrow_back
                    </i>
                </button>
            </div>
            <div class="owl_pagination text-center gap-2 d-flex align-items-center justify-content-center">
                <ng-select [searchable]="false"
                    (change)="onChangePage($event - 1)"
                    [(ngModel)]="dropdownCurrentPage"
                    [items]="pageLegnthDropdown"
                    appearance="outline"
                    [clearable]="false"
                    class="pmd-select pmd-select-outline"
                    name="searchFilter"
                    dropdownPosition="top">
                </ng-select>
                <span class="fs-6">/</span>
                <span class="fw-medium">{{invoice.pageCount}}</span>
            </div>
            <div class="align-self-center">
                <button type="button"
                    (click)="onChangePage(page + 1)"
                    pmdBtn
                    [attr.color]="buttonColor ? buttonColor : null"
                    pmdRipple
                    size="xs"
                    class="btn btn-arrow btn-outline-dark">
                    <i class="material-icons material-icons-outlined pmd-icon-sm">
                        arrow_forward
                    </i>
                </button>
            </div>
        </div>
    </div>
</div>